import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubscriptionService } from '@services/subscription.service';
import { openInactiveSubscriptionModal, openPastDueSubscriptionModal } from '@utils/subscription-modal.utils';
import { catchError, throwError } from 'rxjs';

const excludedEndpoints = [
  '/api/users/prompts',
  '/api/invoices/download',
  '/api/companies/id',
  '/api/companies/me',
  '/api/tickets/client-companies',
  '/api/users/prompts'
];

export const paymentRequiredInterceptor: HttpInterceptorFn = (req, next) => {
  const dialog = inject(MatDialog);
  const subscriptionService = inject(SubscriptionService);
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((error: unknown) => {
      const isExcluded = excludedEndpoints.some((endpoint) => req.url.includes(endpoint));
      if (
        error instanceof HttpErrorResponse &&
        error.status === 402 &&
        !isExcluded &&
        !subscriptionService.isParticular()
      ) {
        if (subscriptionService.isPastDue()) {
          openPastDueSubscriptionModal(dialog, subscriptionService, snackBar);
        } else {
          openInactiveSubscriptionModal(
            dialog,
            subscriptionService.subscriptionExpiredDate(),
            subscriptionService,
            snackBar
          );
        }
      }

      return throwError(() => error);
    })
  );
};
